import React from "react";
import ScreeningQuestionThree from "../shared/ScreeningQuestionThree";
import { handleStoreAlreadyDoneDetails } from "../public/CommonAPIHelper";

const AlreadyDoneQuestionThreeUI = () => {
  return (
    <ScreeningQuestionThree
      questionText="Where was your prior screening performed and what was the result?"
      textFieldLabel="Prior Screening Details"
      backRoute="./2"
      submitRoute="/thankyouresponse"
      onSubmitHandler={handleStoreAlreadyDoneDetails}
    />
  );
};

export default AlreadyDoneQuestionThreeUI;
